module.exports = __webpack_public_path__ + "static/media/oblongata.cf52bf32.ogg";